import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Avatar } from "@mui/material";
import { HiArrowRight, HiXMark } from "react-icons/hi2";

const DashboardSideNavContent = ({
  title,
  subtitle = "Mockee",
  switchLink,
  navItems,
  profiledata,
  isMobile = false,
  onClose,
}) => {
  const handleNavClick = () => {
    if (isMobile && onClose) onClose();
  };

  return (
    <div className="dashboard-sidebar">
      <div className="dashboard-sidebar__header">
        <div className="dashboard-sidebar__brand">
          <img
            src="/assets/images/justLogo.svg"
            alt="Mockee"
            className="dashboard-sidebar__logo"
          />
          <div className="dashboard-sidebar__brand-text">
            <p className="dashboard-sidebar__eyebrow mb-0">{subtitle}</p>
            <h2 className="dashboard-sidebar__title mb-0">{title}</h2>
          </div>
        </div>
        {isMobile && (
          <button
            type="button"
            className="dashboard-sidebar__close"
            onClick={onClose}
            aria-label="Close menu"
          >
            <HiXMark size={22} />
          </button>
        )}
      </div>

      {switchLink && (
        <NavLink
          to={switchLink.to}
          className="dashboard-sidebar__switch"
          onClick={handleNavClick}
        >
          <span>{switchLink.label}</span>
          <HiArrowRight size={18} />
        </NavLink>
      )}

      <nav className="dashboard-sidebar__nav" aria-label="Dashboard navigation">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.link}
              to={item.link}
              className={({ isActive }) =>
                `dashboard-sidebar__link${isActive ? " dashboard-sidebar__link--active" : ""}`
              }
              onClick={handleNavClick}
              end={item.end}
            >
              <span className="dashboard-sidebar__link-icon">
                {Icon ? <Icon size={20} /> : null}
              </span>
              <span className="dashboard-sidebar__link-label">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <div className="dashboard-sidebar__footer">
        <Avatar
          src={profiledata?.profile || "/assets/images/user_vector.svg"}
          alt={profiledata?.full_name || "User"}
          sx={{
            width: 44,
            height: 44,
            flexShrink: 0,
            border: "2px solid rgba(255,255,255,0.12)",
          }}
        />
        <div className="dashboard-sidebar__profile">
          <p
            className="dashboard-sidebar__profile-name mb-0"
            title={profiledata?.full_name || undefined}
          >
            {profiledata?.full_name || "Account"}
          </p>
          {profiledata?.email && (
            <p
              className="dashboard-sidebar__profile-email mb-0"
              title={profiledata.email}
            >
              {profiledata.email}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

DashboardSideNavContent.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  switchLink: PropTypes.shape({
    to: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      icon: PropTypes.elementType,
      end: PropTypes.bool,
    }),
  ).isRequired,
  profiledata: PropTypes.object,
  isMobile: PropTypes.bool,
  onClose: PropTypes.func,
};

export default DashboardSideNavContent;
